import { canUse } from '@/utils/can-use.utils';

export interface PowerClassRule {
  fps: (val: number) => boolean;
  areaRatio: (val: number) => boolean;
  powerClass: 1 | 2 | 3;
  powerClassCompass?: 1 | 2 | 3;
  desc?: string;
}

export type PowerClassRuleType =
  | 'secondPointer'
  | 'sprite'
  | 'default'
  | 'js-lua'
  | 'rive';

const _baseRules: Record<PowerClassRuleType, PowerClassRule[]> = {
  default: [
    {
      fps: () => true,
      areaRatio: () => true,
      powerClass: 1
    },
  ],
  // js 程序短时动效
  'js-lua': [
    {
      fps: () => true,
      areaRatio: () => true,
      powerClass: 2,
      powerClassCompass: 3
    }
  ],
  // 静态背景 + 指针
  secondPointer: [
    {
      fps: (val) => val == 1,
      areaRatio: (val) => val <= 100,
      powerClass: 1,
      powerClassCompass: 2
    },
    {
      fps: (val) => val == 30,
      areaRatio: (val) => true,
      powerClass: 3,
      desc: '序列帧帧率>=30，导致表盘整体功耗为3级'
    },
    {
      fps: (val) => val == 60,
      areaRatio: (val) => val < 13,
      powerClass: 3,
      desc: '序列帧帧率>=30，导致表盘整体功耗为3级'
    },
    {
      fps: (val) => val == 60,
      areaRatio: (val) => val >= 13,
      powerClass: 3,
      desc: '表盘动效面积>=13%，导致表盘整体功耗为3级'
    }
  ],
  // 序列帧 IFTT
  sprite: [
    {
      fps: (val) => val < 15,
      areaRatio: (val) => true,
      powerClass: 2
    },
    {
      fps: (val) => val < 25 && val >= 15,
      areaRatio: (val) => val < 50,
      powerClass: 2
    },
    {
      fps: (val) => val < 25 && val >= 15,
      areaRatio: (val) => val >= 50,
      powerClass: 3,
      desc: '表盘动效面积占比>=50%，导致表盘整体功耗为3级'
    },
    {
      fps: (val) => val >= 25 && val < 35,
      areaRatio: (val) => val < 50,
      powerClass: 3,
      desc: '序列帧帧率>=25，导致表盘整体功耗为3级'
    },
    {
      fps: (val) => val >= 25 && val < 35,
      areaRatio: (val) => val >= 50,
      powerClass: 3,
      desc: '表盘动效面积>=50%，导致表盘整体功耗为3级'
    },
    {
      fps: (val) => val >= 35 && val <= 60,
      areaRatio: (val) => true,
      powerClass: 3,
      desc: '序列帧帧率>=35，导致表盘整体功耗为3级'
    }
  ],
  // 只需要考虑面积占比
  rive: [
    {
      fps: (val) => true,
      areaRatio: (val) => val <= 15,
      powerClass: 2,
      powerClassCompass: 3,
    },
    {
      fps: (val) => true,
      areaRatio: (val) => val > 15,
      powerClass: 3,
      desc: '表盘动效面积占比>15%，导致表盘整体功耗为3级'
    }
  ]
};

/**
 * 获取设备功耗规则
 * @param deviceType
 * @returns
 */
export const getWatchfacePowerRules = (deviceType: string) => {
  if (!canUse('power-class', deviceType).valid) return;
  return _baseRules;
};
